import { MessageDownloadState } from './reducers/downloads';
import { MessageAttachment } from './types';

export const getMessageIsDownloading = (
  downloads: MessageDownloadState,
  attachment: MessageAttachment
) => {
  if (
    downloads[attachment.mediaIdentifier] &&
    downloads[attachment.mediaIdentifier].isDownloading
  ) {
    return true;
  }

  return false;
};
